module.exports = __webpack_public_path__ + "img/通草.193fc52d.jpg";